import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import { ThemeProvider, useTenant } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Tasks from "@/pages/Tasks";
import Workflow from "@/pages/Workflow";
import Orders from "@/pages/Orders";
import BusinessInfo from "@/pages/BusinessInfo";
import Documents from "@/pages/Documents";
import Messages from "@/pages/Messages";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, ready } = useAuth();
  const { tenant } = useTenant();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!tenant.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <DataProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/workflow" element={<Workflow />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/business-info" element={<BusinessInfo />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
        </DataProvider>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
